export default __webpack_public_path__ + "static/media/pdf.338cae3e.jpg";